<template>
    <div class="main">



        <!-- 頁首 -->
        <Header :title="title" :isBack="true" />

        <!-- 主體 -->
        <div class="mainContent">
            <b-tabs style="height:100%;">
                <!-- 頁籤-登記區域分布圖 -->
                <b-tab title="登記區域分布圖" active>
                    <!-- 圖台 -->
                    <div id="map" class="gis-basic">

                        <div class="legend w3-round-large" style="left: unset;right: 0.5rem;min-width: 170px;">
                            <h4 class="legendTitle">年度期作</h4>
                            <b-container class="bv-example-row mb-3" style="padding-right: 5px;padding-left: 5px;">
                                <v-select :searchable="false" :clearable="false" v-model="select" :options="menu.year_period" :reduce="(option) => option.Value" label="Title" style="width: 160px"></v-select>
                            </b-container>
                        </div>
                        <!-- 左上圖例說明 -->
                        <div class="legend w3-round-large">
                            <h4 class="legendTitle">圖例說明</h4>
                            <b-container class="bv-example-row mb-3" style="padding-right: 5px;padding-left: 5px;">
                                <b-row cols="2" style="margin-right: 0px;margin-left: 0px;">

                                    <!-- 農情氣象預警 -->
                                    <b-col class="m-125">
                                        <div class="unit planting-ratio-info red" >
                                            <p class="info">種植面積<br />公頃</p>
                                            <div v-for="(value, key) in openLayers.legend" class="level" :key="'type' + key" style="display: flex;justify-content:space-between;">
                                                <div>{{ value.value }}</div><div class="color" :style="{background:value.color}" style="width: 15px;height: 20px;margin-left:20px;"></div>
                                            </div>
                                        </div>
                                    </b-col>

                                </b-row>
                            </b-container>
                        </div>
                    </div>
                </b-tab>
                <!-- 頁籤-鄉鎮種植面積 -->
                <b-tab title="鄉鎮種植面積">
                    <div class="container">
                        <!-- 標題 -->
                        <PwaTitle :textTitle="openLayers.Data.YunlinTownSelectYear + '年' + openLayers.Data.YunlinTownSelectPeriod + openLayers.Data.YunlinTownSelectTown + '作物種植面積'" :showMore="false"></PwaTitle>
                        <!-- 選單(鄉鎮) -->
                        <select v-if="openLayers.Data.YunlinTown != null" v-model="openLayers.Select.YunlinTown2" class="form-control">
                            <option v-for="(value, key) in openLayers.Data.YunlinTown" :value="value.TOWN_ID" :key="'type' + key" >
                                {{ value.TOWN }}
                            </option>
                        </select>
                        <!-- 圖表 -->
                        <div class="w3-row" style="overflow-x: auto; overflow-y: hidden;">
                            <div id="chart_crop_area_town"></div>
                        </div>
                        <!-- 表格 -->
                        <div class="w3-container">
                            <table class="global-table w3-table w3-striped w3-bordered" v-if="openLayers.Data.YunlinTownSelectCrop != null" >
                                <tr class="header table-tr">
                                    <th>作物名稱</th>
                                    <th>種植面積</th>
                                </tr>
                                <tr class="body" v-for="(item, index) in openLayers.Data.YunlinTownSelectCrop" :key="index" :class="index % 2 === 0 ? 'table-td-single' : 'table-td-double'">
                                    <td>{{ item.NAME }} ({{ item.ID }})</td>
                                    <td>{{ item.AREA_P }} 公頃</td>
                                </tr>
                                <tr class="footer table-tr">
                                    <td>登記種植總面積</td>
                                    <td>{{ openLayers.Data.YunlinTownSelectArea }} 公頃</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </b-tab>
                <!-- 頁籤-雲林縣種植面積 -->
                <b-tab title="雲林縣種植面積">
                    <div class="container">
                        <!-- 標題 -->
                        <PwaTitle v-if="openLayers.Data.YunlinCity != null" :textTitle="openLayers.Data.YunlinCity.A_YEAR + '年' + openLayers.Data.YunlinCity.PERIOD + '雲林縣作物種植面積'" :showMore="false"></PwaTitle>
                        <!-- 圖表 -->
                        <div class="w3-row" style="overflow-x: auto; overflow-y: hidden;">
                            <div id="chart_crop_area_city_town"></div>
                        </div>
                        <!-- 表格 -->
                        <div class="w3-container">
                            <table class="global-table w3-table w3-striped w3-bordered" v-if="openLayers.Data.YunlinCity != null">
                                <tr class="header table-tr">
                                    <th>鄉鎮名稱</th>
                                    <th>種植面積</th>
                                </tr>
                                <tr class="body" v-for="(item, index) in openLayers.Data.YunlinTown" :key="index" :class="index % 2 === 0 ? 'table-td-single' : 'table-td-double'">
                                    <td>{{ item.TOWN }}</td>
                                    <td>{{ item.AREA_P }} 公頃</td>
                                </tr>
                                <tr class="footer table-tr">
                                    <td>登記種植總面積</td>
                                    <td>{{ openLayers.Data.YunlinCity.AREA_P }} 公頃</td>
                                </tr>
                            </table>
                        </div>

                        <!-- 圖表 -->
                        <div class="w3-row" style="overflow-x: auto; overflow-y: hidden;">
                            <div id="chart_crop_area_city_crop"></div>
                        </div>
                        <!-- 表格 -->
                        <div class="w3-container">
                            <table class="global-table w3-table w3-striped w3-bordered" v-if="openLayers.Data.YunlinCity != null">
                                <tr class="header table-tr">
                                    <th>作物名稱</th>
                                    <th>種植面積</th>
                                </tr>
                                <tr class="body" v-for="(item, index) in openLayers.Data.YunlinCity.CROP" :key="index" :class="index % 2 === 0 ? 'table-td-single' : 'table-td-double'">
                                    <td>{{ item.NAME }} ({{ item.ID }})</td>
                                    <td>{{ item.AREA_P }} 公頃</td>
                                </tr>
                                <tr class="footer table-tr">
                                    <td>登記種植總面積</td>
                                    <td>{{ openLayers.Data.YunlinCity.AREA_P }} 公頃</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </b-tab>
            </b-tabs>
        </div>

    </div>
</template>
<script>
import PwaTitle from '@/components/pwa/PwaTitle.vue'
import Header from '@/components/pwa/Header.vue'
import Map from 'ol/Map';
import View from 'ol/View';

import { XYZ,
         Vector as VectorSource,
        } from "ol/source";

import { fromLonLat,
        } from "ol/proj";

import { Tile,
         Vector as VectorLayer,
        } from "ol/layer";
import GeoJSON from "ol/format/GeoJSON";

import {
        Fill,
        Stroke,
        Style
        } from "ol/style";
import { defaults as defaultControls } from 'ol/control';
export default {
    created() {
        window.vue = this;
        //先將圖表設定成 null，否則會有頁面切換回來，圖表無法呈現，沒有反應的問題。
        window.ChartIntelligenceCropArea = null;
        window.ChartIntelligenceCropArea2 = null;

        if(!window.checkLogin()){ window.setPage("login");}
    },
    components: {
        Header,
        PwaTitle
    },
    data(){
        return {

            //api 種植統計數據
            apiPlantStatistics: (data) => this.userRequest.post("/API/Default/PlantStatistics", data),
            //api 種植統計數據(年度期作分群)
            apiPlantStatisticsGroup: (data) => this.userRequest.post("/API/Default/PlantStatisticsGroup", data),
            
            title: "目前種植情形",
            select:null,
            //選單
            menu:{
                //年度期作
                year_period:[],
            },
            //OpenLayers 相關物件
            //備註:因為地圖物件，會用到很多變數，所以統一，所有的地圖變數都宣告在 openLayers 物件內
            //備註:如果沒有特定的初始值，統一用null以方便外部去做判別
            openLayers:{

                //級距
                legend:[],

                //地圖物件
                Map:null,
                //地圖預設值
                Default:
                {
                    //容器的ID
                    Target:'map',
                    //緯度
                    CenterLat:23.652574754046682,
                    //經度
                    CenterLng:120.36276133502504,
                    //TWD97X
                    TWD97X:184992.53879376827,
                    //TWD97Y
                    TWD97Y:2616692.675353226,
                    //視野(Zoom)
                    Zoom:10,
                },
                //圖層
                Layer:{

                    Tile:{
                        //正射影像圖(通用)
                        PHOTO2:null,
                        //臺灣通用電子地圖(無鐵公路)
                        EMAP9:null,
                        //村里界圖
                        Village:null
                    },
                    //雲林行政區
                    YunlinTown:null,
                },
                //樣式
                Style:{

                    //雲林行政區
                    YunlinTown:function(feature){

                        const _this = window.vue._data;
                        var index = -1;
                        for(var i=0 ; i<_this.openLayers.Data.YunlinTown.length ; i++)
                        {
                            //若有在清單內，才呈現
                            if(_this.openLayers.Data.YunlinTown[i].TOWN_ID == feature.values_.County_ID)
                            {
                                index = i;
                            }
                        }

                        //若不在選單內的則不呈現
                        if(index == -1){ return null; }


                        var color = "29, 151, 108";
                        var fill_color = "rgba(0, 0, 0, 0)";
                        var max_area = Number(_this.openLayers.Data.YunlinTown[0].AREA_P);
                        var area = Number(_this.openLayers.Data.YunlinTown[index].AREA_P);

                        if( area >= Number(((max_area * 5)/5).toFixed(2)) ) { fill_color = "rgba(" + color + ", 0.8)"; }
                        else if( area >= Number(((max_area * 4)/5).toFixed(2)) ) { fill_color = "rgba(" + color + ", 0.6)"; }
                        else if( area >= Number(((max_area * 3)/5).toFixed(2)) ) { fill_color = "rgba(" + color + ", 0.4)"; }
                        else if( area >= Number(((max_area * 2)/5).toFixed(2)) ) { fill_color = "rgba(" + color + ", 0.3)"; }
                        else if( area >= Number(((max_area * 1)/5).toFixed(2)) ) { fill_color = "rgba(" + color + ", 0.2)"; }
                        else { fill_color = "rgba(" + color + ", 0.1)"; }

                        _this.openLayers.legend = [];
                        _this.openLayers.legend.push({

                            value:Number(((max_area * 5)/5).toFixed(2)),
                            color:"rgba(" + color + ", 0.8)"
                        });
                        _this.openLayers.legend.push({

                            value:Number(((max_area * 4)/5).toFixed(2)),
                            color:"rgba(" + color + ", 0.6)"
                        });
                        _this.openLayers.legend.push({

                            value:Number(((max_area * 3)/5).toFixed(2)),
                            color:"rgba(" + color + ", 0.4)"
                        });
                        _this.openLayers.legend.push({

                            value:Number(((max_area * 2)/5).toFixed(2)),
                            color:"rgba(" + color + ", 0.3)"
                        });
                        _this.openLayers.legend.push({

                            value:Number(((max_area * 1)/5).toFixed(2)),
                            color:"rgba(" + color + ", 0.2)"
                        });


                        if(_this.openLayers.Select.YunlinTown == feature.values_.County_ID)
                        {
                            //已選取
                            return new Style({

                                //區塊外框線
                                stroke: new Stroke({
                                    //外框線顏色
                                    color: "#FF0000",
                                    //外框線寬度
                                    width: 2
                                }),

                                //區塊樣式
                                fill: new Fill({
                                    color: fill_color,
                                }),

                                //為了讓選擇的圖示，別被其他圖示蓋過，所以zIndex加大
                                zIndex: 11001,   //備註 zIndex 越大會越上層
                            });

                        }else{

                            //未選取
                            return new Style({

                                //區塊外框線
                                stroke: new Stroke({
                                    //外框線顏色
                                    color: "#000000",
                                    //外框線寬度
                                    width: 2
                                }),

                                //區塊樣式
                                fill: new Fill({
                                    color: fill_color,
                                }),

                                //為了讓選擇的圖示，別被其他圖示蓋過，所以zIndex加大
                                zIndex: 11000,   //備註 zIndex 越大會越上層
                            });

                        }
                    },
                },
                //目前選擇
                Select:{
                    YunlinTown:null,
                    YunlinTown2:null,
                },
                //資料數據
                Data:{

                    YunlinCity:null,
                    //範本資料
                    /*
                    YunlinTown:[

                        {
                            TOWN:"虎尾鎮",
                            TOWN_ID:"P03",
                            A_YEAR:113,
                            AREA_P:1.66,
                            CROP:[
                                {
                                    NAME:"休耕",
                                    ID:"-1",
                                    AREA_P:0.58
                                },
                                {
                                    NAME:"粟",
                                    ID:"004",
                                    AREA_P:0.2
                                },
                                {
                                    NAME:"硬質玉米",
                                    ID:"001",
                                    AREA_P:0.19
                                },
                                {
                                    NAME:"食用玉米",
                                    ID:"002",
                                    AREA_P:0.185
                                },
                                {
                                    NAME:"小麥",
                                    ID:"003",
                                    AREA_P:0.182
                                },
                                {
                                    NAME:"蕎麥",
                                    ID:"008",
                                    AREA_P:0.16
                                },
                                {
                                    NAME:"蜀黍(高粱)",
                                    ID:"005",
                                    AREA_P:0.16
                                },
                            ]
                        },
                        {
                            TOWN:"斗六市",
                            TOWN_ID:"P01",
                            A_YEAR:113,
                            AREA_P:3.97,
                            CROP:[
                                {
                                    NAME:"粟",
                                    ID:"004",
                                    AREA_P:1.3
                                },
                                {
                                    NAME:"硬質玉米",
                                    ID:"001",
                                    AREA_P:1.29
                                },
                                {
                                    NAME:"休耕",
                                    ID:"-1",
                                    AREA_P:0.8
                                },
                                {
                                    NAME:"小麥",
                                    ID:"003",
                                    AREA_P:0.18
                                },
                                {
                                    NAME:"蜀黍(高粱)",
                                    ID:"005",
                                    AREA_P:0.17
                                },
                                {
                                    NAME:"食用玉米",
                                    ID:"002",
                                    AREA_P:0.12
                                },
                                {
                                    NAME:"蕎麥",
                                    ID:"008",
                                    AREA_P:0.11
                                },

                            ]
                        },
                        {
                            TOWN:"大埤鄉",
                            TOWN_ID:"P08",
                            A_YEAR:113,
                            AREA_P:12.28,
                            CROP:[
                                {
                                    NAME:"休耕",
                                    ID:"-1",
                                    AREA_P:3.2
                                },
                                {
                                    NAME:"蕎麥",
                                    ID:"008",
                                    AREA_P:2.8
                                },
                                {
                                    NAME:"硬質玉米",
                                    ID:"001",
                                    AREA_P:2.4
                                },
                                {
                                    NAME:"食用玉米",
                                    ID:"002",
                                    AREA_P:1.8
                                },
                                {
                                    NAME:"粟",
                                    ID:"004",
                                    AREA_P:1.1
                                },
                                {
                                    NAME:"蜀黍(高粱)",
                                    ID:"005",
                                    AREA_P:0.8
                                },
                                {
                                    NAME:"小麥",
                                    ID:"003",
                                    AREA_P:0.182
                                },
                            ]
                        },
                        {
                            TOWN:"林內鄉",
                            TOWN_ID:"P10",
                            A_YEAR:113,
                            AREA_P:1.66,
                            CROP:[
                                {
                                    NAME:"休耕",
                                    ID:"-1",
                                    AREA_P:0.58
                                },
                                {
                                    NAME:"粟",
                                    ID:"004",
                                    AREA_P:0.2
                                },
                                {
                                    NAME:"硬質玉米",
                                    ID:"001",
                                    AREA_P:0.19
                                },
                                {
                                    NAME:"食用玉米",
                                    ID:"002",
                                    AREA_P:0.185
                                },
                                {
                                    NAME:"小麥",
                                    ID:"003",
                                    AREA_P:0.182
                                },
                                {
                                    NAME:"蕎麥",
                                    ID:"008",
                                    AREA_P:0.16
                                },
                                {
                                    NAME:"蜀黍(高粱)",
                                    ID:"005",
                                    AREA_P:0.16
                                },
                            ]
                        },
                    ]
                    */
                    YunlinTown:[]
                },
            },
        }
    },
    mounted(){
        window.vue = this;  //在created方法中，將變數全局化，主控台可用 window.vue._data 調閱或呼叫(若不用可以直接遮罩)
                            //例如:window.vue._data.map.getCesiumScene().setEnabled(false);

        //初始地圖
        this.initMap();

    },
    watch: {
        //鄉鎮市區(選擇)
        "openLayers.Select.YunlinTown2": function(){
            var val =  this.openLayers.Select.YunlinTown2;
            if(val != null && val != "")
            {
                this.openLayers.Data.YunlinTownSelectYear = "";
                this.openLayers.Data.YunlinTownSelectPeriod = "";
                this.openLayers.Data.YunlinTownSelectTown = "";
                this.openLayers.Data.YunlinTownSelectArea = "";
                this.openLayers.Data.YunlinTownSelectCrop = [];

                for(var i=0 ; i< this.openLayers.Data.YunlinTown.length ; i++)
                {
                    if(this.openLayers.Data.YunlinTown[i].TOWN_ID == val)
                    {
                        this.openLayers.Data.YunlinTownSelectYear = this.openLayers.Data.YunlinTown[i].A_YEAR;
                        this.openLayers.Data.YunlinTownSelectPeriod = this.openLayers.Data.YunlinTown[i].PERIOD;
                        this.openLayers.Data.YunlinTownSelectTown = this.openLayers.Data.YunlinTown[i].TOWN;
                        this.openLayers.Data.YunlinTownSelectArea = this.openLayers.Data.YunlinTown[i].AREA_P;
                        this.openLayers.Data.YunlinTownSelectCrop = this.openLayers.Data.YunlinTown[i].CROP;
                    }
                }

                this.setAgriSurveyArea();
            }
        },
        "select":function(val)
        {
            this.plantStatistics(val);
        }
    },
    methods: {

        //啟用遮罩
        enableDefaultLoad:function()
        {
            this.enableMask();
            this.default_load = true;
        },

        //取消遮罩
        disableDefaultLoad:function()
        {
            //暫時先設定延遲，否則watch會重複觸發
            const _this = this;
            window.ThreadTool.Delay(function(){

                _this.disableMask();
                _this.default_load = false;

            },this.delay_ms_api);
        },

        // 初始(地圖)
        initMap: function () {

            const _this = this;
            //正射影像圖(通用)
            this.openLayers.Layer.Tile.PHOTO2 = new Tile({
                minZoom: 7,
                maxZoom: 18,
                source: new XYZ({
                    url: "https://wmts.nlsc.gov.tw/wmts/PHOTO2/default/EPSG:3857/{z}/{y}/{x}"
                }),
            });
            //臺灣通用電子地圖(無鐵公路)
            this.openLayers.Layer.Tile.EMAP9 = new Tile({
                minZoom: 7,
                maxZoom: 18,
                source: new XYZ({
                    url: "https://wmts.nlsc.gov.tw/wmts/EMAP/default/EPSG:3857/{z}/{y}/{x}"
                }),
            });
            //村里界圖
            this.openLayers.Layer.Tile.Village = new Tile({
                minZoom: 7,
                maxZoom: 18,
                source: new XYZ({
                    //縣市界
                    //url: "https://wmts.nlsc.gov.tw/wmts/CITY/default/EPSG:3857/{z}/{y}/{x}"
                    //鄉鎮區界
                    //url: "https://wmts.nlsc.gov.tw/wmts/TOWN/default/EPSG:3857/{z}/{y}/{x}"
                    //村里界圖
                    url: "https://wmts.nlsc.gov.tw/wmts/Village/default/EPSG:3857/{z}/{y}/{x}"
                    //地段外圍圖(後期可以考慮這個，這個直接把地段名稱、地段識別碼(範例:奮起段PD0424)秀出來)
                    //url: "https://wmts.nlsc.gov.tw/wmts/LANDSECT/default/EPSG:3857/{z}/{y}/{x}"

                }),
            });
            //雲林行政區
            this.openLayers.Layer.YunlinTown = this.getStandardVectorPlane({

                style: this.openLayers.Style.YunlinTown,
                source_url: "GeoJSON/yunlin.geojson",
                //source_projection:"EPSG:3826",
                onLoad:function(Param){

                    var mResponseText = Param.XMLHttpRequest.responseText;
                    //若坐標系是TWD97請用這個
                    //var mFeatures = (new GeoJSON()).readFeatures(mResponseText);

                    //若坐標系是經緯度請用這個
                    var mFeatures = (new GeoJSON()).readFeatures(mResponseText,{ featureProjection: Param.Projection });
                    _this.openLayers.Layer.YunlinTown.getSource().addFeatures(mFeatures);
                }
            });
            this.openLayers.Layer.YunlinTown.set("LayerId", "openLayers.Layer.YunlinTown");

            //圖台
            this.openLayers.Map = new Map({
                target: _this.openLayers.Default.Target,
                layers: [
                    //臺灣通用電子地圖(無鐵公路)
                    this.openLayers.Layer.Tile.EMAP9,
                    //村里界圖
                    //this.openLayers.Layer.Tile.Village,
                ],
                view: new View({
                    minZoom: 7,
                    maxZoom: 18,
                    center: fromLonLat([_this.openLayers.Default.CenterLng, _this.openLayers.Default.CenterLat]),
                    zoom: _this.openLayers.Default.Zoom
                }),
                controls: defaultControls({
                    zoom: false // 關閉縮放按鈕
                })
            });

            this.openLayers.Map.addLayer(this.openLayers.Layer.YunlinTown);

            if(this.openLayers.Data.YunlinTown.length > 0)
            {
                this.openLayers.Select.YunlinTown = this.openLayers.Data.YunlinTown[0].TOWN_ID;
                this.openLayers.Select.YunlinTown2 = this.openLayers.Data.YunlinTown[0].TOWN_ID;
                this.openLayers.Layer.YunlinTown.getSource().changed();
            }

            /** 註冊監聽事件-當滑鼠單擊時 */
            this.openLayers.Map.on('click', function (e) {

                var pixel = e.pixel;
                var click_event = [];

                //取得所以被觸發的圖層，並將它堆疊再一起
                _this.openLayers.Map.forEachFeatureAtPixel(pixel, function(feature, layer)
                {
                    click_event.push({feature:feature,layer:layer});
                });

                if(click_event.length > 0)
                {
                    //僅取第一個被觸發的圖層
                    var mLayer = click_event[0].layer;
                    var mFeature = click_event[0].feature;
                    var mLayerId = mLayer.get("LayerId");

                    switch(mLayerId){

                        case 'openLayers.Layer.YunlinTown':

                            for(var i=0 ; i<_this.openLayers.Data.YunlinTown.length ; i++)
                            {
                                //若有在清單內，才觸發
                                if(_this.openLayers.Data.YunlinTown[i].TOWN_ID == mFeature.values_.County_ID)
                                {
                                    _this.openLayers.Select.YunlinTown = mFeature.values_.County_ID;
                                    _this.openLayers.Layer.YunlinTown.getSource().changed();
                                }
                            }
                        break;
                    default:
                    }
                }

            });

            /** 註冊監聽事件-當滑鼠放開時 */
            this.openLayers.Map.on('moveend', function (e) {

                console.log(e);
                window.vue.valueProcessZOOM = window.vue.openLayers.Map.getView().getZoom();
            });

            this.plantStatisticsGroup()
        },
        //切換圖層(state=true 加入地圖、state=false 從地圖移除)
        switchLayer: function(layer,state){

            if(state)
            {
                this.openLayers.Map.addLayer(layer);
            }
            else
            {
                this.openLayers.Map.removeLayer(layer);
            }
        },
        //取得圖層-面(實例:GeoJSON)
        getStandardVectorPlane:function(option){

            if(option == undefined || option == null){ option = {};  }

            /** 圖層樣式 */
            if(option.style == undefined || option.style == null){ option.style = null;  }
            /** 資料來源網址 */
            if(option.source_url == undefined || option.source_url == null){ option.source_url = "";  }
            /** 資料來源格式 */
            if(option.source_format == undefined || option.source_format == null){ option.source_format = new GeoJSON();  }
            /** 資料投影 */
            if(option.source_projection == undefined || option.source_projection == null){ option.source_projection = "EPSG:4326";  }


            /** 數據加載時 */
            if(option.onLoad == undefined || option.onLoad == null || typeof(option.onLoad) != 'function')
            {
                option.onLoad = function(aXMLHttpRequest){ console.log(aXMLHttpRequest); }
            }
            /** 程序錯誤時 */
            if(option.onError == undefined || option.onError == null || typeof(option.onError) != 'function')
            {
                option.onError = function(){ alert("加載失敗");  }
            }

            var mVector = new VectorLayer({

                style: option.style,
                source: new VectorSource({

                    format: new GeoJSON(),
                    projection: option.source_projection,
                    loader: function (sourceExtent, resolution, projection) {

                        var mXMLHttpRequest = new XMLHttpRequest();
                        mXMLHttpRequest.open('GET', option.source_url);
                        mXMLHttpRequest.onerror = option.onError;
                        mXMLHttpRequest.onload = function ()
                        {
                            if (mXMLHttpRequest.status == 200)
                            {
                                var Param = {

                                    XMLHttpRequest:mXMLHttpRequest,
                                    SourceExtent:sourceExtent,
                                    Resolution:resolution,
                                    Projection:projection
                                }

                                option.onLoad(Param);
                            }
                            else
                            {
                                option.onError();
                            }
                        }
                        mXMLHttpRequest.send();
                    }

                })

            });

            return mVector;
        },
        //設定作物種植面積(雲林縣)
        setAgriSurveyAreaCityCrop:function()
        {
            var AgriSurveyArea = [];
            var item = this.openLayers.Data.YunlinCity.CROP;

            for(var i=0 ; i<item.length ; i++)
            {
                AgriSurveyArea.push({
                    CROP:item[i].NAME,
                    AREA_P:Number(item[i].AREA_P),
                });
            }

            if(AgriSurveyArea.length > 0)
            {
                var data_area = [];
                for(var i2=0 ; i2<AgriSurveyArea.length ; i2++)
                {
                    data_area.push({
                        //縣市
                        x:AgriSurveyArea[i2].CROP,
                        //種植面積
                        y:this.getRounded(AgriSurveyArea[i2].AREA_P)
                    });
                }

                window.ThreadTool.ClearDelay(window.vue.timeout_id_chart_city_crop);
                window.vue.timeout_id_chart_city_crop = window.ThreadTool.Delay(function(){

                    window.setChartIntelligenceCropArea2("#chart_crop_area_city_crop",{
                        data:data_area
                    });

                },this.delay_ms_chart);
            }

        },
        //設定鄉鎮種植面積(雲林縣)
        setAgriSurveyAreaCityTown:function()
        {
            var AgriSurveyArea = [];
            var item = this.openLayers.Data.YunlinTown;

            for(var i=0 ; i<item.length ; i++)
            {
                AgriSurveyArea.push({
                    TOWN:item[i].TOWN,
                    AREA_P:Number(item[i].AREA_P),
                });
            }

            if(AgriSurveyArea.length > 0)
            {
                var data_area = [];
                for(var i2=0 ; i2<AgriSurveyArea.length ; i2++)
                {
                    data_area.push({
                        //縣市
                        x:AgriSurveyArea[i2].TOWN,
                        //種植面積
                        y:this.getRounded(AgriSurveyArea[i2].AREA_P)
                    });
                }

                window.ThreadTool.ClearDelay(window.vue.timeout_id_chart_city_town);
                window.vue.timeout_id_chart_city_town = window.ThreadTool.Delay(function(){

                    window.setChartIntelligenceCropArea3("#chart_crop_area_city_town",{
                        data:data_area
                    });

                },this.delay_ms_chart);
            }

        },


        //設定作物種植面積
        setAgriSurveyArea:function()
        {
            var TOWN_ID = this.openLayers.Select.YunlinTown2;
            var AgriSurveyArea = [];

            for(var i=0 ; i<this.openLayers.Data.YunlinTown.length ; i++)
            {
                if(this.openLayers.Data.YunlinTown[i].TOWN_ID == TOWN_ID)
                {

                    var year = this.openLayers.Data.YunlinTown[i].A_YEAR;
                    var town = this.openLayers.Data.YunlinTown[i].TOWN;
                    console.log(year);
                    console.log(town);
                    var item = this.openLayers.Data.YunlinTown[i].CROP;

                    for(var i2=0 ; i2<item.length ; i2++)
                    {
                        AgriSurveyArea.push({
                            CROP:item[i2].NAME,
                            AREA_P:Number(item[i2].AREA_P),
                        });
                    }
                }
            }

            if(AgriSurveyArea.length > 0)
            {
                var data_area = [];
                for(var i3=0 ; i3<AgriSurveyArea.length ; i3++)
                {
                    data_area.push({
                        //縣市
                        x:AgriSurveyArea[i3].CROP,
                        //種植面積
                        y:this.getRounded(AgriSurveyArea[i3].AREA_P)
                    });
                }

                window.ThreadTool.ClearDelay(window.vue.timeout_id_chart_town);
                window.vue.timeout_id_chart_town = window.ThreadTool.Delay(function(){

                    window.setChartIntelligenceCropArea("#chart_crop_area_town",{
                        data:data_area
                    });

                },this.delay_ms_chart);

            }
        },
        //種植統計數據
        plantStatistics:function(val){
            this.enableDefaultLoad();
            this.apiPlantStatistics({
                A_YEAR:val.A_YEAR,
                PERIOD:val.PERIOD
            })
            .then((res)=>{

                const data = JSON.parse(res.data);
                if(data.TownPlantStatistics.length > 0)
                {
                    this.openLayers.Data.YunlinCity = data.CityPlantStatistics;
                    this.openLayers.Data.YunlinTown = data.TownPlantStatistics;

                    this.openLayers.Data.YunlinCity.AREA_P = this.getRounded(this.openLayers.Data.YunlinCity.AREA_P);

                    for(var i=0 ; i<this.openLayers.Data.YunlinCity.CROP.length ; i++)
                    {
                        this.openLayers.Data.YunlinCity.CROP[i].AREA_P = this.getRounded(this.openLayers.Data.YunlinCity.CROP[i].AREA_P);
                    }

                    for(var i2=0 ; i2<this.openLayers.Data.YunlinTown.length ; i2++)
                    {
                        this.openLayers.Data.YunlinTown[i2].AREA_P = this.getRounded(this.openLayers.Data.YunlinTown[i2].AREA_P);

                        for(var i3=0 ; i3<this.openLayers.Data.YunlinTown[i2].CROP.length ; i3++)
                        {
                            this.openLayers.Data.YunlinTown[i2].CROP[i3].AREA_P = this.getRounded(this.openLayers.Data.YunlinTown[i2].CROP[i3].AREA_P);
                        }

                    }

                    console.log(this.openLayers.Data.YunlinCity)
                    console.log(this.openLayers.Data.YunlinTown)


                    this.openLayers.Select.YunlinTown = this.openLayers.Data.YunlinTown[0].TOWN_ID;
                    this.openLayers.Select.YunlinTown2 = this.openLayers.Data.YunlinTown[0].TOWN_ID;
                    this.openLayers.Layer.YunlinTown.getSource().changed();
                    this.setAgriSurveyAreaCityCrop();
                    this.setAgriSurveyAreaCityTown();

                }else{

                    alert("目前沒有任何種植登記紀錄");
                }

                window.vue.disableDefaultLoad();
            })
            .catch((err)=> {
                console.log(err);
                window.vue.disableDefaultLoad();
            });
        },

        //種植統計數據(年度期作分群)
        plantStatisticsGroup:function(){
            this.enableDefaultLoad();
            this.apiPlantStatisticsGroup({

            })
            .then((res)=>{

                const data = JSON.parse(res.data);
                console.log(data);
                this.menu.year_period = [];
                for(var i=0 ; i<data.length ; i++)
                {
                    this.menu.year_period.push({
                        Title:data[i].A_YEAR + " " + data[i].PERIOD,
                        Value:data[i]
                    }); 
                }
                window.vue.disableDefaultLoad();
                
                if(this.menu.year_period.length > 0)
                {
                    this.plantStatistics(data[0]);
                    this.select = data[0];
                }
            })
            .catch((err)=> {
                console.log(err);
                window.vue.disableDefaultLoad();
            });
        },
    }
}
</script>
<style>

    #map {
        width: 100%;
        height: 100vh;
        min-height: 70vh;
        background: #FFFFFF;
    }

    .table-tr {

        background: #1D976C;
        color: #FFFFFF;
    }

    .table-td-single {

        background: #ecfff8;
        color: #000000;
    }

    .table-td-double {

        background: #99D0BC;
        color: #000000;
    }

</style>
